import { AxiosError } from "axios";
import PartnersShowcaseService, {
  Location,
} from "#/api/partnersShowcase/partnersShowcase";
import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import useLocationConfigurationStore from "#/stores/location-configuration.store";
import useErrorConfigurationStore from "#/stores/error-configuration.store";
import { handlerDatalayer } from "#/utils/handlerdatalayer";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}
type GetLocationProps = {
  options?: UseQueryOptions<Location, AxiosError, Location>;
  zipCode: string;
};

export const useGetLocationConfiguration = ({
  options = {},
  zipCode,
}: GetLocationProps) => {
  const { setLocationConfiguration } = useLocationConfigurationStore();
  const { setErrorConfiguration } = useErrorConfigurationStore();

  return useQuery(
    ["location", zipCode] as QueryKey,
    () => PartnersShowcaseService.getLocation(zipCode),
    {
      ...options,
      enabled: !!zipCode,
      onSuccess: (response: Location) => {
        handlerDatalayer({
          dataLayer: {
            event: "sicredi_parceiros",
            nome_do_evento: "busca_cep",
            acao: zipCode,
          },
        });

        setErrorConfiguration({ message: undefined });
        setLocationConfiguration(response);
      },
      onError: () => {
        setErrorConfiguration({
          message: "Falha ao buscar CEP. Tente novamente.",
        });
      },
    }
  );
};
